<template>
  <el-dialog :close-on-click-modal="false"
             lock-scroll
             :close-on-press-escape="false"
             :show-close="false"
             center
             :visible.sync="tabInitialClick"
             width="300px">
    <div style="text-align: center; font-weight: bold; font-size: 16px; color: black; padding: 30px 0 20px">
      登陆状态失效，请重新登陆！
    </div>
    <template #footer>
      <el-button type="primary" @click="confirm">确定</el-button>
      <el-input type="text" ref="inputdata" class="hiddenIpt" @keyup.enter.native="confirm"/>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'ReLoginDialog',
    methods: {
      confirm () {
        this.$store.dispatch('user/clearToken').then(() => {
          window.location.reload()
        })
      }
    },
    computed: {
        tabInitialClick () {
            this.$nextTick(() => {
                this.$refs.inputdata.focus()
            })
            return this.$store.state.user.showReLoginDialog
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__header {
    padding: 0;
  }
  .hiddenIpt {
  width: 1px;
  opacity: 0;
}
</style>
